export class Search {
    anotherModel: any = {};
    skip: number = 0;
    limit: number = 10;
    totalItems: number = 0;
}



// WEBPACK FOOTER //
// ./src/app/models/Search.model.ts